export const IDENTITY_PROVIDER_LOGWIEN = 'logwien';
